// Personal photos provided by Nishant. Only these images of the person are used site-wide.
export const PORTRAIT_PRIMARY =
  "https://customer-assets.emergentagent.com/job_portfolio-showcase-2296/artifacts/tc67z5td_8B59415C-AA51-4629-B1C5-67322885CD48_1_105_c.jpeg";
export const PORTRAIT_SECONDARY =
  "https://customer-assets.emergentagent.com/job_portfolio-showcase-2296/artifacts/zaqk2y7t_9C9D7616-38FA-46F1-AD08-699403DF98F0_1_105_c.jpeg";
